module.exports = __webpack_public_path__ + "static/media/uib3.2af81607.png";